import styled from 'styled-components';

export const StyledFeedbackBanner = styled.div`
  background-color: ${props =>
    props.error
      ? props.theme.colors.status.errorPrimary
      : props.theme.colors.background.base};
  color: ${props =>
    props.error
      ? props.theme.colors.text.lightest
      : props.theme.colors.text.primary};
  width: 100%;
  font-size: 0.875rem;
  line-height: 21px;
  padding: ${props => (props.error ? '9px' : '12px')};
  @media ${props => props.theme.tabletS} {
    padding: 12px;
  }
`;

export const Paragraph = styled.p`
  display: ${props => (props.error ? 'flex' : 'block')};
`;

export const Icon = styled.img`
  margin-right: 9px;
`;
